var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89001 14.0601H4.81C3.67 14.0601 2.75 14.9801 2.75 16.1201V19.2001C2.75 20.3401 3.67 21.2601 4.81 21.2601H7.89001C9.03001 21.2601 9.95001 20.3401 9.95001 19.2001V16.1201C9.94001 14.9801 9.02001 14.0601 7.89001 14.0601Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94 14.0599L14.06 9.93994",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.08 8.91992V11.9999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.08 8.91992H12",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.73 16.02H12.73C12.32 16.02 11.98 16.36 11.98 16.77C11.98 17.18 12.32 17.52 12.73 17.52H15.73C16.14 17.52 16.48 17.18 16.48 16.77C16.48 16.36 16.14 16.02 15.73 16.02Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.23 13.52C20.82 13.52 20.48 13.86 20.48 14.27V14.77C20.48 15.46 19.92 16.02 19.23 16.02H18.73C18.32 16.02 17.98 16.36 17.98 16.77C17.98 17.18 18.32 17.52 18.73 17.52H19.23C20.75 17.52 21.98 16.29 21.98 14.77V14.27C21.98 13.86 21.64 13.52 21.23 13.52Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.23 7.52002C20.82 7.52002 20.48 7.86002 20.48 8.27002V11.27C20.48 11.68 20.82 12.02 21.23 12.02C21.64 12.02 21.98 11.68 21.98 11.27V8.27002C21.98 7.86002 21.64 7.52002 21.23 7.52002Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.23 2.02002H18.73C18.32 2.02002 17.98 2.36002 17.98 2.77002C17.98 3.18002 18.32 3.52002 18.73 3.52002H19.23C19.92 3.52002 20.48 4.08002 20.48 4.77002V5.27002C20.48 5.68002 20.82 6.02002 21.23 6.02002C21.64 6.02002 21.98 5.68002 21.98 5.27002V4.77002C21.98 3.25002 20.75 2.02002 19.23 2.02002Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.73 2.02002H12.73C12.32 2.02002 11.98 2.36002 11.98 2.77002C11.98 3.18002 12.32 3.52002 12.73 3.52002H15.73C16.14 3.52002 16.48 3.18002 16.48 2.77002C16.48 2.36002 16.14 2.02002 15.73 2.02002Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72998 2.02002H9.22998C7.70998 2.02002 6.47998 3.25002 6.47998 4.77002V5.27002C6.47998 5.68002 6.81998 6.02002 7.22998 6.02002C7.63998 6.02002 7.97998 5.68002 7.97998 5.27002V4.77002C7.97998 4.08002 8.53998 3.52002 9.22998 3.52002H9.72998C10.14 3.52002 10.48 3.18002 10.48 2.77002C10.48 2.36002 10.14 2.02002 9.72998 2.02002Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22998 7.52002C6.81998 7.52002 6.47998 7.86002 6.47998 8.27002V11.27C6.47998 11.68 6.81998 12.02 7.22998 12.02C7.63998 12.02 7.97998 11.68 7.97998 11.27V8.27002C7.97998 7.86002 7.63998 7.52002 7.22998 7.52002Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e100fefaf07138a678dcaaba480e6b34.svg";
export { ForwardRef as ReactComponent };